import React, { useContext, useEffect, useState } from 'react';
import styles from './DashboardPageAppMfg.module.css';
import { useSelector } from 'react-redux';
import { Avatar, Paper } from '@mui/material';
import IconStatCard from 'CommonComponents/IconStatCard';
import { getAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { StyledTabs } from 'CommonComponents/StyledTabs';
import { StyledTab } from 'CommonComponents/StyledTabs';
import { a11yProps } from 'CommonComponents/StyledTabs';
import AllChartsComponents from './AllChartsComponent';
import { getWholeData } from 'Redux/DashboardVariables';

const InventoryCounting = () => {
  const wholeData = useSelector(getWholeData);
  const {
    unfinishedPartCount,
    reworkedPartCount,
    rackWithPartCount,
    emptyRackDetectedCount,
    cHookWithRackCount,
    cHookWithoutRackCount,
    numberPlateDetectedCount,
    partsData,
    racksData,
    cHookData
  } = useSelector(getAnalyticSummaryPageData);

  const [tabValue, setTabValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  // console.log('main log analytic summary: ', statCardData);

  let displayAvatar = (bgcolor, icon) => {
    return (
      <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
        {icon}
      </Avatar>
    );
  }

  const DisplayCard = (useCase) => {
    return (
      <Paper
        key={useCase.title}
        elevation={0}
        style={{
          background: "transparent",
          width: "50%",
          padding: '2px 1px',
          boxSizing: 'border-box',
        }}
      >
        <IconStatCard
          title={useCase.title}
          subheader={useCase.subheader}
          body={useCase.body}
          footer={useCase.footer}
          cardStyle={{ height: '100%', boxShadow: 'none' }}
          headerStyle={{ textAlign: 'left' }}
          avatar={useCase.avatar}
          footerButtonOnClick={useCase.footerButtonOnClick}
        />
      </Paper>
    );
  }

  // console.log('main log analytic summary ge: ', videoData);

  return (
    <>
      <div className={styles.topContainer}>
        <div className={styles.leftColumnContainer} style={{ paddingLeft: "0px" }}>
          <div style={{ width: "100%" }}>
            <Paper elevation={0} style={{
              overflow: 'hidden',
              padding: '10px 10px',
              fontSize: "12px",
              color: "#757575",
              marginBottom: '2px'
            }}>
              <div style={{ display: 'flex' }}>
                <div style={{
                  width: "100%",
                  fontFamily: 'Lato, sans-serif',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  Key Analytics
                </div>
              </div>
            </Paper>
          </div>
          <div style={{ display: 'flex' }}>
            <div className={styles.topContainerDashboard} style={{ margin: "0px 0px 0px 0px", display: "flex", flexWrap: "wrap" }}>
              {DisplayCard({
                avatar: displayAvatar('#1F363D', <CenterFocusStrongIcon />),
                title: 'Unfinished Parts', body: unfinishedPartCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#FFAB40', <CenterFocusStrongIcon />),
                title: 'Reworked Parts', body: reworkedPartCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar: displayAvatar('#1F363D', <CenterFocusStrongIcon />),
                title: 'Racks With Parts', body: rackWithPartCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#FFAB40', <CenterFocusStrongIcon />),
                title: 'Empty Racks', body: emptyRackDetectedCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#1F363D', <CenterFocusStrongIcon />),
                title: 'C Hooks With Rack', body: cHookWithRackCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#FFAB40', <CenterFocusStrongIcon />),
                title: 'C Hooks Without Rack', body: cHookWithoutRackCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#1F363D', <CenterFocusStrongIcon />),
                title: 'Number Plates Detected', body: numberPlateDetectedCount, footer: 'Total'
              })}
              {DisplayCard({
                avatar: <div></div>,
                title: ' ', body: ' '
              })}
            </div>
          </div>
        </div>
        <div className={styles.rightColumnContainer}>
          <Paper elevation={0} style={{
            overflow: 'hidden',
            padding: '10px 10px',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <StyledTabs
              value={tabValue}
              onChange={handleChangeTabs}
              aria-label="styled tabs example"
            >
              <StyledTab label="Parts" {...a11yProps(0)} />
              <StyledTab label="Racks" {...a11yProps(1)} />
              <StyledTab label="C Hooks" {...a11yProps(2)} />
            </StyledTabs>
            {tabValue === 0 && <AllChartsComponents allChartsData={partsData} />}
            {tabValue === 1 && <AllChartsComponents allChartsData={racksData} />}
            {tabValue === 2 && <AllChartsComponents allChartsData={cHookData} />}
          </Paper>
        </div>
      </div>
    </>
  );
};


export default InventoryCounting;

